import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchPatientMessages = async ({ patientId, page = 1, pageSize = 10, trialId }) => {
  const token = localStorage.getItem("token");
  if (!patientId) throw new Error("patientId is required to fetch patient messages");

  const params = new URLSearchParams();
  params.append("patient_id", patientId);
  params.append("page", page);
  params.append("page_size", pageSize);
  if (trialId) params.append("trial_id", trialId);

  const URL = `${__API_URL__}/api/patient/patient/messages/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetPatientMessages = ({ patientId, page = 1, pageSize = 10, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["patient_messages", patientId, page, pageSize, trialId],
    queryFn: () => fetchPatientMessages({ patientId, page, pageSize, trialId }),
    enabled: enabled && Boolean(patientId && patientId > 0),
    keepPreviousData: true,
  });
};

export default useGetPatientMessages;
